import type { CreateShareSavingsAccountForChildProcess } from '@generated-types';
import { useProcess } from '@react-query/hooks/query/use-process';
import { useSession } from '@react-query/hooks/query/use-session';

interface UseProcessRoleResult {
    hasApplicantRole: boolean;
    hasApproverRole: boolean;
}

export const useProcessRole = (explicitProcess?: CreateShareSavingsAccountForChildProcess): UseProcessRoleResult => {
    const { data: session, isSuccess } = useSession();
    const { data: implicitProcess } = useProcess();
    const process = explicitProcess ?? implicitProcess;

    if (!process || !isSuccess) {
        return {
            hasApplicantRole: false,
            hasApproverRole: false,
        };
    }

    const sessionFnr = session.fnr.value;
    const hasApplicantRole = sessionFnr === process.applicantParent.fnr.value;
    const hasApproverRole = sessionFnr === process.approverParent.fnr.value;

    return {
        hasApplicantRole,
        hasApproverRole,
    };
};
